import { dashboardLocationColor } from '@/lib/dashboardColors'
import { Link } from 'react-router-dom'
import { Button, Skeleton } from '@mantine/core'
import Box from '@/components/ui/Box'
import DashboardDetailPopover from './DashboardDetailPopover'

const number = new Intl.NumberFormat('fr-FR')
const date = (value) => new Date(`${value}T12:00:00`).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })

function Models({ models }) {
    return <dl className="mt-3 space-y-2 border-t pt-3 text-sm">
        {models.map((model) => <div key={model.component_id} className="flex justify-between gap-4">
            <dt className="min-w-0">{model.name}</dt>
            <dd className="shrink-0 tabular-nums font-medium">{number.format(model.quantity)}</dd>
        </div>)}
    </dl>
}

export default function DashboardAssemblyActivity({ production_orders, error, retry }) {
    const max = Math.max(1, ...(production_orders || []).flatMap((site) => (site.activity || []).map((week) => Number(week.quantity))))
    return (
        <section className="space-y-3" aria-label="Activité des assemblages">
            <div className="flex items-center justify-between gap-3">
                <h2 className="font-medium">Mises en stock des assemblages</h2>
                <Link to="/assembly?status=open,scheduled" className="text-sm text-blue-500">Voir tout</Link>
            </div>
            {error && <div role="alert" className="flex items-center gap-3 text-sm text-gray-500">
                Impossible d’actualiser les assemblages.
                <Button variant="subtle" onClick={retry}>Réessayer</Button>
            </div>}
            <div className="grid grid-cols-1 @3xl:grid-cols-2 @5xl:grid-cols-3 gap-5">
                {!production_orders && !error && [0, 1, 2].map((key) => <Skeleton key={key} height={260} radius="lg" />)}
                {production_orders?.map((site) => {
                    const total = site.activity.reduce((sum, week) => sum + Number(week.quantity), 0)
                    const name = site.location_name.trim()
                    return <Box key={site.location_id} title={<Link to={`/assembly?location_id=${site.location_id}&status=open,scheduled`} className="inline-flex items-center gap-2"><span className="size-2 rounded-full" style={{ backgroundColor: dashboardLocationColor(site.location_id) }} aria-hidden="true" />{name}</Link>}>
                        <div className="mt-2 mb-3 flex justify-between gap-2 text-xs text-gray-500">
                            <span>{number.format(total)} mises en stock</span><span>4 semaines</span>
                        </div>
                        <div className="grid grid-cols-4 gap-3">
                            {site.activity.map((week) => <div key={week.start} className="min-w-0">
                                <DashboardDetailPopover label={`${name}, semaine du ${date(week.start)} : ${number.format(week.quantity)} mises en stock`}
                                    className="h-32 w-full" trigger={
                                        <span className="flex h-full w-full items-end justify-center border-b border-gray-100">
                                            <span className="flex w-full max-w-12 flex-col items-center justify-end">
                                                <span className="mb-1 text-xs text-gray-600 tabular-nums">{number.format(week.quantity)}</span>
                                                <span className="block w-full rounded-t" style={{ backgroundColor: dashboardLocationColor(site.location_id), opacity: week.is_current ? 1 : 0.4, height: `${Math.max(2, Number(week.quantity) / max * 104)}px` }} />
                                            </span>
                                        </span>
                                    }>
                                    <p className="text-xs text-gray-500">Du {date(week.start)} au {date(week.end)}{week.is_current ? ' (en cours)' : ''}</p>
                                    <p className="mt-1 text-sm font-medium">{number.format(week.quantity)} mises en stock</p>
                                    {week.models.length > 0 && <Models models={week.models} />}
                                </DashboardDetailPopover>
                                <p className="mt-2 text-center text-xs text-gray-500">{week.is_current ? 'En cours' : date(week.start)}</p>
                            </div>)}
                        </div>
                    </Box>
                })}
            </div>
        </section>
    )
}
